import { createSelector } from 'reselect';
import { formatHeightRange } from '../../../../util/string';

// ================ Action types ================ //
const SET_HEIGHT_FILTERS = 'app/ReviewsFilter/SET_HEIGHT_FILTERS';
const SET_SIZE_TYPE = 'app/ReviewsFilter/SET_SIZE_TYPE';
const SET_SIZE_FILTERS = 'app/ReviewsFilter/SET_SIZE_FILTERS';
const SET_TYPE_FILTERS = 'app/ReviewsFilter/SET_TYPE_FILTERS';
const SET_BRAND_FILTERS = 'app/ReviewsFilter/SET_BRAND_FILTERS';
const APPLY_FILTERS = 'app/ReviewsFilter/APPLY_FILTERS';
const SET_MULTIPLE_FILTERS = 'app/ReviewsFilter/SET_MULTIPLE_FILTERS';
const RESET_FILTERS = 'app/ReviewsFilter/RESET_FILTERS';

const initialFilterValues = {
  pub_height: '',
  sizeType: 'clothing',
  size: '',
  pub_categoryLevel1: '',
  pub_brandSlug: '',
  brandName: '',
};

const initialState = {
  draft: { ...initialFilterValues },
  applied: { ...initialFilterValues },
};

export default function reviewsFilterReducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case SET_HEIGHT_FILTERS:
      return {
        ...state,
        draft: {
          ...state.draft,
          pub_height: payload,
        },
      };
    case SET_SIZE_TYPE:
      return {
        ...state,
        draft: {
          ...state.draft,
          sizeType: payload,
          pub_categoryLevel1: payload,
          size: '', // Reset size when type changes
        },
      };
    case SET_SIZE_FILTERS:
      return {
        ...state,
        draft: {
          ...state.draft,
          size: payload,
        },
      };
    case SET_TYPE_FILTERS:
      return {
        ...state,
        draft: {
          ...state.draft,
          pub_categoryLevel1: payload,
        },
      };
    case SET_BRAND_FILTERS:
      return {
        ...state,
        draft: {
          ...state.draft,
          pub_brandSlug: typeof payload === 'string' ? payload : payload?.pub_brandSlug || '',
          brandName: typeof payload === 'string' ? '' : payload?.brandName || '',
        },
      };
    case APPLY_FILTERS:
      // Copy draft to applied
      return {
        ...state,
        applied: { ...state.draft },
      };

    case SET_MULTIPLE_FILTERS:
      // Allows setting multiple filters at once
      return {
        ...state,
        draft: { ...payload },
        applied: { ...payload },
      };

    case RESET_FILTERS:
      return {
        ...state,
        draft: { ...initialFilterValues },
        applied: { ...initialFilterValues },
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //
export const setHeightFilters = payload => ({
  type: SET_HEIGHT_FILTERS,
  payload,
});

export const setSizeType = payload => {
  return {
    type: SET_SIZE_TYPE,
    payload,
  };
};

export const setSizeFilters = payload => ({
  type: SET_SIZE_FILTERS,
  payload,
});

export const setTypeFilters = payload => ({
  type: SET_TYPE_FILTERS,
  payload,
});

export const setBrandFilters = payload => ({
  type: SET_BRAND_FILTERS,
  payload,
});

export const applyFilters = () => ({
  type: APPLY_FILTERS,
});

export const setMultipleFilters = payload => ({
  type: SET_MULTIPLE_FILTERS,
  payload,
});

export const resetFilters = () => ({
  type: RESET_FILTERS,
});

// ================ Selectors ================ //

export const selectDraftFilters = state => state.ReviewsFilter.draft;
export const selectAppliedFilters = state => state.ReviewsFilter.applied;

export const selectActiveFilters = createSelector(
  [selectAppliedFilters],
  filters => {
    // Convert to API query format
    const activeFilters = {};

    Object.entries(filters).forEach(([key, value]) => {
      if (value.length) {
        if (key === 'pub_height') {
          activeFilters.pub_height = formatHeightRange(value);
        } else if (key === 'size') {
          if (filters.sizeType === 'clothing') {
            activeFilters.pub_ClothingSize = value;
          } else {
            activeFilters.pub_ShoeSize = value;
          }
        } else {
          if (key !== 'sizeType') activeFilters[key] = value;
        }
      }
    });

    return activeFilters;
  }
);

export const selectDraftFilterCount = createSelector(
  [selectDraftFilters],
  filters => {
    let count = 0;
    if (filters.pub_height) count++;
    if (filters.size) count++;
    if (filters.pub_categoryLevel1) count++;
    if (filters.pub_brandSlug || filters.brandName) count++;
    return count;
  }
);
